import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { useLocation, useSearchParams, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useDebouncedCallback } from "use-debounce";

export default function Search({
  placeholder,
  className,
  query = "query",
  showIcon = true,
  maxLength = 255,
  numberOnly = false,
  numberAndLetter = false,
}: {
  placeholder: string;
  className?: string;
  query?: string;
  showIcon?: boolean;
  maxLength?: number;
  numberOnly?: boolean;
  numberAndLetter?: boolean;
}) {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [value, setValue] = useState(searchParams.get(query)?.toString());
  const navigate = useNavigate();
  const { pathname } = location;
  const isInit = useRef(true);

  useEffect(() => {
    console.log("location", location);
    const params = new URLSearchParams(searchParams);
    setValue(params?.get(query) || "");
  }, []);

  useEffect(() => {
    if (value == undefined) {
      return;
    }
    if (isInit.current) {
      isInit.current = false;
      return;
    } else {
      handleSearch(value);
    }
  }, [value]);

  const handleSearch = useDebouncedCallback((term) => {
    const params = new URLSearchParams(searchParams);
    params.set("page", "1");
    if (term) {
      params.set(query, encodeURIComponent(term));
    } else {
      params.delete(query);
    }
    navigate(`${pathname}?${params.toString()}`, { replace: true });
  }, 500);

  return (
    <div
      className={className ? className : "relative flex flex-1 flex-shrink-0"}
    >
      <label htmlFor="search" className="sr-only">
        Search
      </label>
      <input
        id="search"
        className="peer block w-full rounded-2xl border border-gray-200 py-[9px] pl-10 text-sm outline-2 placeholder:text-gray-500"
        placeholder={placeholder}
        maxLength={maxLength}
        onChange={(e) => {
          if (numberOnly) {
            setValue(e.target.value?.replace(/[^0-9]/g, ""));
          }
          if (numberAndLetter) {
            setValue(e.target.value?.replace(/[^0-9a-zA-Z]/g, ""));
          } else {
            setValue(e.target.value);
          }

          //handleSearch(e.target.value);
        }}
        value={value || ""}
      />
      {showIcon && (
        <MagnifyingGlassIcon className="absolute left-3 top-1/2 h-[18px] w-[18px] -translate-y-1/2 text-gray-500 peer-focus:text-gray-900" />
      )}
    </div>
  );
}
